export const headers = [{ content: "Member" }, { content: "Role" }, { content: "Property" }, { content: "Inncode" }];
